import { connect } from 'react-redux';

import SpaceSettingsTabPanel from './SpaceSettingsTabPanel';
import AllTabs from './AllTabs';
import { openParticipants, openGroups } from '../../../../actions/navigation';
import { settingsTab } from '../../../../selectors/routing';
import {
  currentClassRoomId,
  classRoomName,
} from '../../../../../core/selectors/classroom';

const visibleTabs = (state) => AllTabs.filter((tab) => tab.visible(state));

const mapStateToProps = (state) => ({
  tabs: visibleTabs(state),
  currentTabId: settingsTab(state),
  spaceId: currentClassRoomId(state),
  currentSpaceName: classRoomName(state),
});

const TabToAction = {
  participants: openParticipants,
  groups: openGroups,
};

const mapDispatchToProps = (dispatch) => ({
  onTabChange: (tabs, newTabIndex, spaceId) => {
    const tabId = tabs[newTabIndex].id;
    const action = TabToAction[tabId];
    dispatch(action(spaceId));
  },
});

const mergeProps = (
  { tabs, spaceId, ...otherStateProps },
  { onTabChange, ...otherDispatchProps },
  ownProps
) => ({
  ...otherStateProps,
  ...otherDispatchProps,
  ...ownProps,
  tabs,
  onTabChange: (_event, newTabIndex) => onTabChange(tabs, newTabIndex, spaceId),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(SpaceSettingsTabPanel);
